import Vue from 'vue'
import EasyVue from './EasyVue'
import settings from './settings.js'
import directives from './directive';
import './components/global'  // 引入全局组件注册文件
import './self_directive'  // 引入自定义指令

// 引用font-awesome图标库
import 'font-awesome/css/font-awesome.css';

Vue.config.productionTip = false

Vue.use(directives);

//该方法是为input属于添加字符数的限制，如在TextBox中添加v-maxlength="10"
Vue.directive('maxlength', {
  // 指令绑定到元素时
  bind(el, binding) {
      // 使用MutationObserver监听DOM变化，确保TextBox渲染完成后设置maxlength
      const observer = new MutationObserver(() => {
          const input = el.querySelector('input') || el.querySelector('textarea');
          if (input && !input.hasAttribute('maxlength')) {
              input.setAttribute('maxlength', binding.value);
              observer.disconnect(); // 设置完成后停止观察
          }
      });
      
      // 开始观察
      observer.observe(el, {
          childList: true,
          subtree: true
      });
      
      // 立即尝试设置一次（如果input已经存在）
      const input = el.querySelector('input') || el.querySelector('textarea');
      if (input) {
          input.setAttribute('maxlength', binding.value);
      }
  },
  
  // 指令值更新时
  update(el, binding) {
      const input = el.querySelector('input') || el.querySelector('textarea');
      if (input) {
          input.setAttribute('maxlength', binding.value);
      }
  }
});


// 导入所有项目模块入口文件
const modulesFiles = require.context('../modules', true, /module_index.js$/);

// 存储所有模块对象
// 该功能的目的就是把default的方案挂载到modeult对象上
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\/module_index.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

// 获得模块排序数组
const modulesSortList = settings.modulesSortList;
if (modulesSortList && modulesSortList.length > 0) {
  // 如果配置了模块排序数组，则按照模块排序数组加载
  for (let i = 0; i < modulesSortList.length; i++) {
    if (modules[modulesSortList[i]]) {
      EasyVue.add(modules[modulesSortList[i]]);
    }
  }
} else {
  // 未配置模块排序数组，则把所有模块对象都进行加载
  for (const moduleName in modules) {
    EasyVue.add(modules[moduleName]);
  }
}

new EasyVue({
  settings
}).$mount('#app')
